import { BannerType, EventType} from 'environments/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { SessionService } from 'app/components/common/session/session.service';
import { SearchService } from 'app/components/search/search.service';
import { UtilsService } from 'app/components/utils/utils.service';
import { DetailsService } from '../../components/details/details.service';
import { FiltersService } from '../../components/filters/filters.service';
import { Subject, takeUntil, Subscription } from 'rxjs';
import { BannersService } from '../../components/banners/banners.service';
import { LanguagesService } from '../../components/languages/languages.service';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../services/shared.service';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { AnalyticsService } from 'app/components/analytics/analytics.service';
import { LoginService } from 'app/components/login/login.service';

@Component({
  selector: 'app-exhibitors',
  templateUrl: './exhibitors.component.html',
  styleUrls: ['./exhibitors.component.css']
})
export class ExhibitorsComponent implements OnInit, OnDestroy {

  //items: any[] = [];  // Aquí irán los items que se mostrarán
  
  seeMoreColor: string = '#fff';
  mainColor: string = '#fff';
  show: boolean = false;
  numElements: number = 0;
  private numItemsSubscription: Subscription;

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  searchConfig: object = {};
  
  items: any[] = []; // Asegúrate de definir tu array de items según tu necesidad
  private itemsSubscription: Subscription;

  eventData: EventType;
  detailsJson: object = {};

  page: number = 0;

  selectedView:string;

  private readonly destroy$ = new Subject();

  addMore = false;


  constructor(public catalogueService: CatalogueService, private sessionService: SessionService, public searchService: SearchService,
  private utilsService: UtilsService, private detailsService: DetailsService, public filtersService:FiltersService,
  private bannerService:BannersService, private languageService:LanguagesService, public translateService: TranslateService,
  private sharedService:SharedService, private activatedRoute: ActivatedRoute, private titleService:Title, private analyticsService: AnalyticsService,
  public loginService: LoginService) { 
    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    this.searchService.setItemsObs([]);
    this.searchService.setNumItemsObs(0);
  }



  unifiedSearch(unifiedSearchIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.searchService.unifiedSearch(unifiedSearchIn)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: object) => {
        this.unifiedSearchOk(data);
      },
        error => {
          this.unifiedSearchError(error);
        });

  }

  unifiedSearchOk(data) {
    this.loader.count--;
    this.searchService.setItemsObs(data.list);
    this.searchService.setNumItemsObs(data.numElements);
    this.show = true;
    this.analyticsService.sendViewItemList(data.list, 'exhibitor', this.selectedView);
  }

  unifiedSearchError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getProperty(key){
    return this.detailsService.getPropertyByKey(key, false);
  }

  isSponsored(item) {
    //const hasSelectedProperties = !this.helpers.isEmpty(this.searchStatus.selectedHierarchicalProperties);
    //const hasSelectedSectors = !this.helpers.isEmpty(this.searchStatus.selectedSectors);
    //if (!hasSelectedProperties && !hasSelectedSectors) {
    //  return this.item.sponsoredInHomePage;
    //}
    //return this.item.sponsoredByCategories || this.item.sponsoredBySector;
    
    return item.sponsoredByCategories || item.sponsoredBySector;
  }

  isFeatured(item) {
    return item.featured;
  }

  showAddMore(){
    if(this.searchConfig['size'] * this.page >= this.numElements - this.searchConfig['size']){
        return false;
    }
    return true;
  }

  pages(){

    this.addMore = true;

    let unifiedSearchIn = this.searchService.getSearchConfig();

    this.page++;
    unifiedSearchIn['page'] = this.page;

    this.unifiedSearch(unifiedSearchIn);

  }


  configBanner(banner) {

    switch(this.selectedView) {
      case 'grid':
        banner.position =  5;
        banner.width = '198';
        banner.height = '320';
        break;
      case 'modern':
        banner.position =  3;
        banner.width = '305';
        banner.height = '370';
        break;
      case 'list':
        banner.position =  4;
        banner.width = '1280';
        banner.height = '164';
        break;
    }


    return banner;

  }


  getBannerRandom(getBannerRandomIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.bannerService.getBannerRandom(getBannerRandomIn)
      .subscribe((data: object) => {
        this.getBannerRandomOk(data);
      },
        error => {
          this.getBannerRandomError(error);
        });

  }

  getBannerRandomOk(data) {

    this.loader.count--;
    this.banners = data || [];
    this.getSearchConfig();
    this.unifiedSearch(this.searchConfig);

  }

  getBannerRandomError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
    this.getSearchConfig();
    this.unifiedSearch(this.searchConfig);

  }


  getBannerByType(type):BannerType {

    let newBanner = {
      position: 0,
      url: '',
      link: '',
      type: '',
      width: '',
      height: '',
      id: null
    }

    let banner:BannerType =  {
      position: 0,
      url: '',
      link: '',
      type: '',
      width: '',
      height: '',
      id: null
    };

    for (let i = 0; i < this.banners.length; i++) {
      if (this.banners[i]['frontView']['name'] === type) {
        banner = this.banners[i];
        banner.type = 'banner';
        banner = this.configBanner(banner);
      }
    }
 
    return (banner.url)?banner:newBanner;

  }

  checkPageSize() {

    let bannerProperties = this.getBannerByType(this.selectedView);

    if (bannerProperties.url) {
      this.setPageSizeWithBanner();
    } else {
      this.setPageSize();
    }

  }

  setPageSizeWithBanner() {

    switch(this.selectedView) {
      case 'grid':
        this.searchConfig['size'] = 17;
        break;
      case 'modern':
        this.searchConfig['size'] = 11;
        break;
      case 'list':
        this.searchConfig['size'] = 9;
        break;

    }

  }

  setPageSize() {

    switch(this.selectedView) {
      case 'grid':
        this.searchConfig['size'] = 18;
        break;
      case 'modern':
        this.searchConfig['size'] = 12;
        break;
      case 'list':
        this.searchConfig['size'] = 10;
        break;

    }

  }

  getSearchConfig(){
    
    let eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');

    this.searchConfig = this.searchService.getSearchConfig();
    this.searchConfig['brand'] = '';
    this.searchConfig['filter'] = 'ONLY_EXHIBITORS';
    this.searchConfig['sapCode'] = eventData.sapCode;
    this.searchConfig['page'] = this.page;

    this.checkPageSize();

    this.searchService.setSearchConfig(this.searchConfig);//FIXME cambiar en las demas vistas

    this.addMore = false;

  }

  uploadData(){

    let catalogId = JSON.parse(this.sessionService.get('catalogId', false));

    let getBannerRandomIn = {
      catalogueId: catalogId
    };

    this.getBannerRandom(getBannerRandomIn);

    this.checkPageSize();

    //this.unifiedSearch(this.searchConfig);

  }

  favorites = {};

  getFavoriteResources() {

    let eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    let eventName = JSON.parse(this.sessionService.get('eventName', false));
    let token = this.sessionService.get('token_' + eventData['sapCode'], true);
    let acount = JSON.parse(this.sessionService.get('profile_' + eventData['sapCode'], true) || '{}');

    let getFavoriteResourcesIn = {
      event:  eventName,
      token: token,
      user: acount.username
    };

    this.catalogueService.getFavoriteResources(getFavoriteResourcesIn)
        .subscribe((result) => {
              this.getFavoriteResourcesOk(result);
            },
            error => {
              console.log("[getFavoriteResources]ERROR",error);//FIXME sacar la parte del login
            });

  }

  getFavoriteResourcesOk(data: any){

    this.favorites = data;

  }

  banners = [];

  ngOnInit() {
    
    this.getSearchConfig();

    this.seeMoreColor = this.detailsService.getPropertyByKey('colors.save.favoriteText', true);;
    this.mainColor = this.eventData['mainColor'];
    this.searchService.setItemsObs(this.items);

    this.getFavoriteResources();

    this.itemsSubscription = this.searchService.getItemsObs()
      .subscribe(newItems => {
        if(this.addMore){
          newItems.forEach(item => {
            this.items.push(item);
          });
        }
        else
          this.items = newItems;
    });

    this.numItemsSubscription = this.searchService.getNumItemsObs()
      .subscribe(newItemsSize => {
        this.numElements = newItemsSize;
    });

    this.searchService.getResetList()
    .pipe(takeUntil(this.destroy$))
    .subscribe(active => {
      this.addMore = false;
      if(active)
        this.items = [];
    });

    this.filtersService.getSelectedView()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      if(!this.utilsService.isEmpty(data)){
        this.page = 0;
        this.selectedView = data;
        this.searchService.setItemsObs([]);
        this.items = [];
        this.uploadData();
      }
    });
    
    this.sharedService.updateUrl();

    this.titleService.setTitle(this.catalogueService.getProperty('label'));

  }

  ngOnDestroy(): void {
    if (this.itemsSubscription) {
      this.itemsSubscription.unsubscribe();
    }
    if (this.numItemsSubscription) {
      this.numItemsSubscription.unsubscribe();
    }
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
